/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { ListChecks } from 'lucide-react';
import { chamarApi } from '@/nucleo/auth/cliente-api';
import { Button } from '@/ui/base/button';

const NS = '/bff/v1/j10-s02-analista-triar-solicitacao';

export function TriarSolicitacaoPage() {
  const [estado, setEstado] = useState<any>();
  const [ocupado, setOcupado] = useState(false);
  async function chamar(caminho: string, corpo?: unknown) {
    setOcupado(true);
    try {
      const resposta = await chamarApi<any>(NS + caminho, {
        metodo: caminho === '/state' ? 'GET' : 'POST',
        corpo,
      });
      setEstado(resposta.state);
    } finally {
      setOcupado(false);
    }
  }
  useEffect(() => {
    void chamar('/state');
  }, []);
  if (!estado) return <p role="status">Carregando triagem…</p>;
  return (
    <main className="w-full min-w-0 space-y-5 overflow-x-hidden">
      <h1 className="text-3xl font-semibold">
        <ListChecks className="mr-2 inline" />
        {estado.titulo}
      </h1>
      <p>{estado.descricao}</p>
      {estado.alertas.map((a: any) => (
        <p role="alert" key={a.codigo}>
          {a.mensagem} <code>{a.codigo}</code>
        </p>
      ))}
      {estado.pedidos.map((p: any) => (
        <article className="space-y-3 rounded-md border p-4" key={p.id}>
          <h2 className="font-semibold">
            {p.protocolo} · {p.status} · versão {p.versao}
          </h2>
          <p>
            Fila {p.fila} · unidade {p.unidade_destino} · alçada {p.alcada}
          </p>
          <p>{p.descricao}</p>
          <p>
            {p.pendencias.length} pendência(s) · {p.eventos.length} movimento(s) de fila
          </p>
          {['PROTOCOLADA', 'EM_TRIAGEM'].includes(p.status) && p.fila === 'ALTERACOES_OS' && (
            <Button
              disabled={ocupado}
              onClick={() =>
                void chamar('/verbs/redistribuir_triagem', {
                  solicitacaoId: p.id,
                  filaDestino: 'TRIAGEM_DTP_PRIORITARIA',
                  motivo: 'Redistribuição conforme prioridade e recorte técnico da solicitação.',
                  chaveIdempotencia: crypto.randomUUID(),
                })
              }
            >
              Redistribuir pela regra
            </Button>
          )}
          {['PROTOCOLADA', 'EM_TRIAGEM'].includes(p.status) && (
            <Button
              disabled={ocupado}
              onClick={() =>
                void chamar('/verbs/pedir_complemento', {
                  solicitacaoId: p.id,
                  motivo: 'Especifique a alteração solicitada e apresente comprovante atualizado.',
                  campos: 'descricao_e_comprovante',
                  prazoDias: 2,
                  chaveIdempotencia: crypto.randomUUID(),
                })
              }
            >
              Pedir complemento
            </Button>
          )}
          {p.status === 'EM_TRIAGEM' && p.versao > 1 && (
            <Button
              disabled={ocupado}
              onClick={() =>
                void chamar('/verbs/encaminhar_decisao', {
                  solicitacaoId: p.id,
                  observacao: 'Completude conferida; versão encaminhada à alçada competente.',
                  chaveIdempotencia: crypto.randomUUID(),
                })
              }
            >
              Encaminhar para decisão
            </Button>
          )}
          <code className="break-all">{p.id}</code>
        </article>
      ))}
      {estado.resultado && (
        <p role="status">Operação persistida: {JSON.stringify(estado.resultado)}</p>
      )}
    </main>
  );
}
